/* ============
 * Mutation types for the account module
 * ============
 *
 * The mutation types that are available
 * on the auth module.
 */

export const CHECK = 'CHECK';
export const REGISTER = 'REGISTER';
export const REFRESH = 'REFRESH';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const UPDATE_COMPANY_INFO = 'UPDATE_COMPANY_INFO';
export const UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE';
export const UPDATE_E_INVOICE_ROLE = 'UPDATE_E_INVOICE_ROLE';
export const UPDATE_LICENSE = 'UPDATE_LICENSE';
export const GET_SUBSCRIPTIONS_MONITOR = 'GET_SUBSCRIPTIONS_MONITOR';

export default {
  CHECK,
  REGISTER,
  REFRESH,
  LOGIN,
  LOGOUT,
  UPDATE_COMPANY_INFO,
  UPDATE_USER_PROFILE,
  UPDATE_E_INVOICE_ROLE,
  UPDATE_LICENSE,
  GET_SUBSCRIPTIONS_MONITOR,
};



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutation-types.js